import { LandingPageRegExpList } from './constants';
import { parseQuery, stringifyQuery } from './query';

export function generate(fullPath: string) {
  const [pathname, query, hash] = fullPath.split(/[?#]/);
  const exists = LandingPageRegExpList.find((item) => item.test(pathname));

  if (exists) {
    return '/';
  }

  let target = pathname;

  if (query) {
    target += `?${stringifyQuery(parseQuery(query, { exclude: ['token'] }))}`;
  }

  if (hash) {
    target += `#${hash}`;
  }

  return encodeURIComponent(target);
}

export function take(fullPath: string) {
  if (fullPath == null || fullPath === '') {
    return '/';
  }

  return decodeURIComponent(fullPath);
}
